<template>
  <b-dropdown
    size="sm"
    variant="outline-primary"
    :text="dropdownText"
    :disabled="!hasAvailableTriggers"
    class="user-actions-dropdown"
  >
    <b-dropdown-item
      v-for="trigger in availableTriggers"
      :key="trigger.name"
      @click="$emit('trigger-action', trigger.name)"
      :disabled="loading"
    >
      {{ trigger.verboseName }}
    </b-dropdown-item>
    
    <b-dropdown-divider v-if="hasUnavailableTriggers && availableTriggers.length > 0" />
    
    <b-dropdown-header v-if="hasUnavailableTriggers">
      Unavailable Actions
    </b-dropdown-header>
    
    <b-dropdown-item
      v-for="trigger in unavailableTriggers"  
      :key="trigger.name"
      disabled
      class="text-muted"
    >
      {{ trigger.verboseName }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "UserStateDropdown",
  props: {
    user: {
      type: Object,
      required: true,
    },
    allTriggers: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    availableTriggers() {
      console.log("User object:", this.user);
      console.log("User triggers:", this.user.triggers);
      if (!this.user.triggers) return [];

      return this.user.triggers.map(triggerName => ({
        name: triggerName,
        verboseName: this.allTriggers[triggerName]?.verboseName || triggerName,
      }));
    },
    unavailableTriggers() {
      const allTriggerNames = Object.keys(this.allTriggers);
      const availableTriggerNames = this.user.triggers || [];
      
      return allTriggerNames
        .filter(triggerName => !availableTriggerNames.includes(triggerName))
        .filter(triggerName => this.allTriggers[triggerName]?.userTrigger)
        .map(triggerName => ({
          name: triggerName,
          verboseName: this.allTriggers[triggerName].verboseName,
        }));
    },
    hasAvailableTriggers() {
      return this.availableTriggers.length > 0;
    },
    hasUnavailableTriggers() {
      return this.unavailableTriggers.length > 0;
    },
    dropdownText() {
      if (this.loading) return "Processing...";
      if (!this.hasAvailableTriggers) return "No Actions";
      return "Actions";
    },
  },
};
</script>

<style scoped>
.user-actions-dropdown {
  min-width: 100px;
}
</style>